// src/pages/Home.js
import React, { useEffect, useState } from "react";
import Welcome from "./sections/Welcome";
import Subscribe from "./sections/Subscribe";
import GuidedTour from "./sections/GuidedTour";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaInfoCircle, FaCogs, FaEdit, FaFileAlt, FaEye } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

function Home() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // Smooth scrolling
      });
    }, 200); // 200ms delay to ensure rendering is complete
  }, []);
  const handleInputChange = (event) => {
    setEmail(event.target.value);
    setError("");
  };

  return (
    <>
      <Helmet>
        <title>Home - Leap</title>
        <meta name="description" content="Welcome to the home page of Leap." />
      </Helmet>
      <div className="">
        <div className="">
          <div className="leap-relative ">
            <div className="leap-pt-14 xl:leap-pt-0">
              <Welcome />
            </div>
          </div>
          <div className="leap-relative ">
            <div className="leap-absolute lg:-leap-top-24 leap-left-0 leap-right-0">
              <Subscribe
                handleInputChange={handleInputChange}
                email={email}
                setEmail={setEmail}
                error={error}
                setError={setError}
              />
            </div>
          </div>
          <div className="map-tours"></div>
          <div className="guided-tour">
            <GuidedTour />
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
